import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

export const absoluteContainerCss: CSSObject = {
  position: "absolute",
  left: "-32px",
  top: "44px",
  zIndex: 10,
  display: "flex",
  alignItems: "center",
  width: "max-content",
  gap: "0.5rem",
  background: constants.colors.ui.core[100],
  color: constants.colors.ui.core[700],
  padding: "0.375rem 0.625rem",
  borderRadius: "0.5rem",

  ":before": {
    position: "absolute",
    top: "-4px",
    left: "45%",
    width: "12px",
    height: "12px",
    content: '""',
    backgroundColor: "inherit",
    transform: "rotate(45deg)",
  },
};

export const assignmentsIconCss = {
  root: {
    marginTop: "1px",
    width: "1.5rem",
    height: "1.5rem",

    path: {
      stroke: constants.colors.ui.core[700],
      strokeWidth: "3px",
    },
  },
};
